import { html } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";

function templateBasic(
	trackingCategory,
	trackingName,
	trackingLabel,
	url,
	content,
) {
	return html`<esc-impression-interaction-tracker
		content-name="${trackingCategory} - ${trackingName}"
		content-piece=${trackingLabel}
		content-target=${url}
	>
		<a
			class="partner-banner__link"
			href=${url}
			target="_blank"
			rel="nofollow noopener"
		>
			${content}
		</a>
	</esc-impression-interaction-tracker>`;
}

export function templateImage(
	trackingCategory,
	trackingName,
	trackingLabel,
	url,
	content,
) {
	return templateBasic(
		trackingCategory,
		trackingName,
		trackingLabel,
		url,
		html`<div class="partner-banner__header">
				<div class="partner-banner__hint">
					${translate("basic_advertisement")}
				</div>
			</div>
			${content}`,
	);
}

export function templateTextAndButton(
	trackingCategory,
	trackingName,
	trackingLabel,
	url,
	firstLine,
	secondLine,
	thirdLine,
	ariaLabel,
	logo,
) {
	return templateBasic(
		trackingCategory,
		trackingName,
		trackingLabel,
		url,
		html`<div class="partner-banner__header">
				<div class="partner-banner__first-line">${firstLine}</div>
				<div class="partner-banner__hint">
					${translate("basic_advertisement")}
				</div>
			</div>
			<div class="partner-banner__content">
				<div class="partner-banner__text">
					<strong>${secondLine}</strong>
					${thirdLine}
				</div>

				<button class="partner-banner__button" aria-label=${ariaLabel}>
					${logo}
				</button>
			</div>`,
	);
}
